import { render } from "./KenyaChapterContent.vue?vue&type=template&id=5ac6a116&ts=true"
import script from "./KenyaChapterContent.vue?vue&type=script&lang=ts"
export * from "./KenyaChapterContent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__